import * as React from 'react';
import * as classNames from 'classnames';

export interface MdcMenuProps {
  isOpen: boolean;
  isBottomToTop?: boolean;
}

const MdcMenu: React.SFC<MdcMenuProps> = (props) => {
  // メニューは本来領域外クリックで消えるが、その機能は未実装（デバッグ用には消えない方が好都合）。
  // ボタン再クリックでメニューを消せるようにするため、ボタンを隠さない程度に位置を調節する。
  // TODO : UI全面作り直し時にちゃんとする。
  const style = props.isBottomToTop === true ?
    { right: '10px', bottom: '0' } : { right: '10px', top: '50px' };

  const cls = classNames('mdc-menu', { 'mdc-menu--open': props.isOpen });

  return (
    <div className="mdc-menu-anchor">
      <div style={style} className={cls} tabIndex={-1}>
        <ul className="mdc-menu__items mdc-list" role="menu">
          {props.children}
        </ul>
      </div>
    </div>
  );
};

export default MdcMenu;
